import type { ReactElement } from 'react'
import { useField } from 'formik'

type Props = {
  name: string
  children: (value: any, setValue: (newValue: any) => void) => ReactElement
}
export default function FormikValue({ name, children }: Props): ReactElement {
  const [{ value }, , { setValue }] = useField(name)
  return children(value, setValue)
}
